// extracted by mini-css-extract-plugin
export default {"loader":"loader_loader__dPlHQ","loader-rotate":"loader_loader-rotate__S9mr4","loader-dash":"loader_loader-dash__H6z4v"};